import DefaultLayout from '@/components/layouts/DefaultLayout';
import { useGetUser } from '@/hooks/requests/useUser';
import { Card, Typography } from '@mui/material';
import ProfileEditStaffForm from './ProfileEditStaffForm';

export default function ProfileEditStaff() {
  const { user } = useGetUser();

  if (!user) {
    return (
      <DefaultLayout header="Profile">
        <Card>
          <Typography>
            Something went wrong retreiving your user information. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout header="Profile">
      <ProfileEditStaffForm user={user} />
    </DefaultLayout>
  );
}
